import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { AppRouter } from "./routers/AppRouter";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { esES } from "@mui/material/locale";
import { green } from "@mui/material/colors";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const theme = createTheme(
  {
    typography: {
      allVariants: {
        fontFamily: ["Rubik", "Montserrat ", "Roboto", '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
      },
    },
    palette: {
      primary: {
        main: green[600],
      },
    },
  },
  esES,
);

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

root.render(
  <ThemeProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  </ThemeProvider>,
);

reportWebVitals();
